import Fullscreen from "@coworker/apprestructured/src/task-management/components/Fullscreen/Fullscreen";
import FullscreenContent from "@coworker/apprestructured/src/task-management/components/Fullscreen/FullscreenContent/FullscreenContent";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import Linkbar from "@coworker/apprestructured/src/shared/components/Linkbar/Linkbar";
import SwitchDemo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/SwitchDemo";
import CustomTaskDescriptionDemo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/CustomTaskDescriptionDemo";
import TitledTextDemo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/TitledTextDemo";
import TitledBoxedTextDemo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/TitledBoxedTextDemo";
import CompletableChecklistDemo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/CompletableChecklistDemo";
import styles from "./ComponentDemoPage.module.css";
import AddImagesDemo from "./demos/AddImagesDemo";
import AssignToDemo from "./demos/AssignToDemo";
import LoadingViewerTopDemo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/LoadingViewerTopDemo";
import MenuSheetDemo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/MenuSheetDemo";
import AttachArticlesDemo from "./demos/AttachArticlesDemo";
import TaskScheduleDemo from "./demos/TaskScheduleDemo";
import CloseSheetDemo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/CloseSheetDemo";
import PersonAndTeamDemo from "./demos/PersonAndTeamDemo";
import AttachFilesDemo from "./demos/AttachFilesDemo";
import RefillQuantityDemo from "./demos/RefillQuantityDemo";
import PendingTaskCardDemo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/PendingTaskCardDemo";
import ClosedTaskCardDemo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/ClosedTaskCardDemo";
import CompletedTaskCardDemo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/CompletedTaskCardDemo";
import TextModalDemo from "./demos/TextModalDemo";
import LoadingTaskCardDemo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/LoadingTaskCardDemo";
import PickupAndRefillLocationDemo from "./demos/PickupAndRefillLocationDemo";
import ImagesDemo from "./demos/ImagesDemo";
import FilesDemo from "./demos/FilesDemo";
import LogsAndCommentsDemo from "./demos/LogsAndCommentsDemo";
import SelectItemWithDescriptionDemo from "./demos/SelectItemWithDescriptionDemo";
import MultipleArticlesDemo from "./demos/MultipleArticlesDemo";
import SelectItemSheetDemo from "./demos/SelectItemSheetDemo";
import AddLocationDemo from "./demos/AddLocationDemo";
import AttachArticleDemo from "./demos/AttachArticleDemo";
import MfaqQuestionHeaderDemo from "./demos/MfaqQuestionHeaderDemo";

function ComponentDemoPage() {
  return (
    <Fullscreen>
      <Linkbar currentLabel="Task management components" currentAsH1 />
      <FullscreenContent className={styles["fullscreenContent"]}>
        <FixaText tagName="h2" textStyle="Heading.XL">
          Task creation fragments
        </FixaText>
        <FixaText tagName="h3" textStyle="Heading.L">
          Settings
        </FixaText>
        <AddImagesDemo />
        <AssignToDemo />
        <AttachFilesDemo />
        <SwitchDemo />
        <TaskScheduleDemo />
        <FixaText tagName="h3" textStyle="Heading.L">
          Other
        </FixaText>
        <AddLocationDemo />
        <AttachArticleDemo />
        <AttachArticlesDemo />
        <CustomTaskDescriptionDemo />
        <MfaqQuestionHeaderDemo />
        <PickupAndRefillLocationDemo />
        <RefillQuantityDemo />
        <SelectItemSheetDemo />
        <SelectItemWithDescriptionDemo />
        <TextModalDemo />
        <FixaText tagName="h2" textStyle="Heading.XL">
          Task viewer top fragments
        </FixaText>
        <CloseSheetDemo />
        <MenuSheetDemo />
        <LoadingViewerTopDemo />
        <MultipleArticlesDemo />
        <FixaText tagName="h2" textStyle="Heading.XL">
          Task viewer fragments
        </FixaText>
        <ImagesDemo />
        <FilesDemo />
        <CompletableChecklistDemo />
        <LogsAndCommentsDemo />
        <PersonAndTeamDemo />
        <TitledBoxedTextDemo />
        <TitledTextDemo />
        <FixaText tagName="h2" textStyle="Heading.XL">
          Task cards
        </FixaText>
        <PendingTaskCardDemo />
        <CompletedTaskCardDemo />
        <ClosedTaskCardDemo />
        <LoadingTaskCardDemo />
      </FullscreenContent>
    </Fullscreen>
  );
}

export default ComponentDemoPage;
